import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import SalesDetailPage from './SalesDetailPage';
import { toastError } from '../../../shared/toastHelper';

const axios = require('axios').default;

function ReportingClassesReportPage({
  team, csrfToken, venueOwnerships, config, reportPath, filterErrorMessage, buildFilterGroups, ...props
}) {
  const [filterOptions, setFilterOptions] = useState({});

  useEffect(() => {
    if (!team?.id) return undefined;
    if (csrfToken) axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    let ignore = false;
    axios.get(`/teams/${team.id}/reporting/classes/${reportPath}/filter_options.json`)
      .then((res) => { if (!ignore) setFilterOptions(res.data || {}); })
      .catch(() => {
        if (!ignore) toastError(filterErrorMessage);
      });
    return () => { ignore = true; };
  }, [team?.id, csrfToken, reportPath, filterErrorMessage]);

  return (
    <>
      <SalesDetailPage
        {...props}
        team={team}
        csrfToken={csrfToken}
        venueOwnerships={venueOwnerships}
        config={{ ...config, buildFilterGroups: () => buildFilterGroups(filterOptions, venueOwnerships) }}
      />
      <ToastContainer />
    </>
  );
}

export default ReportingClassesReportPage;
